
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crop-png",
      function () {
        return require("private-next-pages/crop-png/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crop-png"])
      });
    }
  